var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet04Gray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 6.33332V4.79999C13.3334 4.05325 13.3334 3.67989 13.188 3.39467C13.0602 3.14379 12.8562 2.93981 12.6054 2.81198C12.3201 2.66666 11.9468 2.66666 11.2 2.66666H3.46671C2.71997 2.66666 2.3466 2.66666 2.06139 2.81198C1.8105 2.93981 1.60653 3.14379 1.4787 3.39467C1.33337 3.67988 1.33337 4.05325 1.33337 4.79999V11.2C1.33337 11.9467 1.33337 12.3201 1.4787 12.6053C1.60653 12.8562 1.8105 13.0602 2.06139 13.188C2.3466 13.3333 2.71997 13.3333 3.46671 13.3333L11.2 13.3333C11.9468 13.3333 12.3201 13.3333 12.6054 13.188C12.8562 13.0602 13.0602 12.8562 13.188 12.6053C13.3334 12.3201 13.3334 11.9467 13.3334 11.2V9.66666M10 7.99999C10 7.69022 10 7.53533 10.0257 7.40654C10.1309 6.87762 10.5443 6.46415 11.0733 6.35894C11.2021 6.33332 11.3569 6.33332 11.6667 6.33332H13C13.3098 6.33332 13.4647 6.33332 13.5935 6.35894C14.1224 6.46415 14.5359 6.87762 14.6411 7.40654C14.6667 7.53533 14.6667 7.69022 14.6667 7.99999C14.6667 8.30976 14.6667 8.46464 14.6411 8.59344C14.5359 9.12236 14.1224 9.53583 13.5935 9.64104C13.4647 9.66666 13.3098 9.66666 13 9.66666H11.6667C11.3569 9.66666 11.2021 9.66666 11.0733 9.64104C10.5443 9.53583 10.1309 9.12236 10.0257 8.59344C10 8.46464 10 8.30976 10 7.99999Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet04Gray);
export default __webpack_public_path__ + "static/media/wallet-04_gray.c978e6f8479fb7f7f226b5fe52b9c00f.svg";
export { ForwardRef as ReactComponent };